import * as React from 'react';
import { Box, Button, Flex, Input, Text, Textarea } from "@chakra-ui/react";
import { ContactUsPropTypes } from "./ContactUsPropTypes";
import { FormField, SubmitButton } from "../../components/form";
import { localisable } from "../../generic/localisable";
import { clearButtonProps } from "./constants";
import { Icon } from 'components/icon';

export const RenderFormBody = ({ formConfig, formTitle, currentFormProps, isEmailSent, setIsEmailSent }: ContactUsPropTypes.IRenderContactUsFormProps) => {

    const { name, phone, email, subject, message } = formConfig;
    const { form, initialValues } = currentFormProps || {};

    const renderPageTitle = () => {
        return <Text textStyle='h2' textAlign='left'>{formTitle}</Text>
    };

    const renderFormBody = () => {
        return <Flex direction='column' gap='24px'>
            {isEmailSent && <Flex backgroundColor='background.successMessage' border='1px solid' borderColor='border.successMessage' padding='8px' justifyContent='space-between' alignItems='center'>
                <Text textStyle='body1' color='text.green' >{localisable.contactThankyouMessage}</Text>
                <Box cursor='pointer'>
                    <Icon
                        size={'md'}
                        className='icon-tfw-clear'
                        onClick={() => setIsEmailSent(false)}
                    />
                </Box>
            </Flex>}
            <Flex direction={{ base: 'column', md: 'row' }} gap='24px'>
                <FormField {...name}>
                    <Input />
                </FormField>
                <FormField {...phone}>
                    <Input />
                </FormField>
            </Flex>
            <Flex direction={{ base: 'column', md: 'row' }} gap='24px'>
                <FormField {...email}>
                    <Input />
                </FormField>
                <FormField {...subject}>
                    <Input />
                </FormField>
            </Flex>
            <Flex>
                <FormField {...message}>
                    <Textarea />
                </FormField>
            </Flex>
            <Flex direction={{ base: 'column', md: 'row' }} gap='16px' justifyContent={{ base: 'center', md: 'flex-end' }} alignItems='center'>
                <Button
                    {...clearButtonProps}
                    onClick={() => form.restart(initialValues)}
                >
                    {localisable.clear}
                </Button>
                <SubmitButton
                    w={{ base: '100%', md: '50%' }}
                    formProps={currentFormProps}
                />
            </Flex>
        </Flex>
    }

    return (
        <Flex direction='column' gap='24px'>
            {renderPageTitle()}
            {renderFormBody()}
        </Flex>
    )
};